export default __webpack_public_path__ + "static/media/waterjet.fd9df8f6.png";